export default __webpack_public_path__ + "static/lunarArrival-3319e5f91de1cef72a4887d75579547a.mp3";